module.exports = __webpack_public_path__ + "static/media/blog-35-img3.55578304.webp";